import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    remitente: {},
    nombreTitularEnvio:"",
    infoOneRemitente: {NOMBRE_COMPLETO:""}
  },
  mutations: {
    chargeRemitente(state, datos) {
      state.remitente = datos;
    },
    chargeNombreTitularEnvio(state, datos) {
      state.nombreTitularEnvio = datos;
    },
    getInfoEnvioRemitente(state, datos) {
      for (let i = 0; i < datos.DIRECCION.length; i++) {
        datos.DIRECCION[i].indice = i;
        delete datos.DIRECCION[i].pais;
      }
      state.infoOneRemitente = datos;
    },
    chargeRemitenteUpdatedTarifa(state, datos) {

      state.remitente.tarifaClienteEspecifica.tarifa = datos.TARIFA;
      state.remitente.tarifaClienteEspecifica.ID = datos.ID;
      state.remitente.tarifaClienteEspecifica.descripcion = datos.DESCRIPCION;
    },
    destroyRemitente(state) {
      state.remitente = {};
      state.infoOneRemitente = {NOMBRE_COMPLETO:""};
      state.nombreTitularEnvio="";
    },
  },
  actions: {
    async chargeRemitenteUpdatedTarifa({ commit }, remTar) {
      console.warn(remTar, 'das');
      commit('chargeRemitenteUpdatedTarifa', remTar);
    },
    async getInfoEnvioRemitente({
      commit,
    }, idRem) {
      try {
        const res = await api.getInfoEnvioRemitente(idRem);

        if (res.data.INFO.cod === '200') {
          commit('getInfoEnvioRemitente', res.data.DATOS[0]);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },
    async chargeRemitente({ commit }, remitente) {
      commit('chargeRemitente', remitente);
    },
    async chargeNombreTitularEnvio({ commit }, titular) {
      commit('chargeNombreTitularEnvio', titular);
    },
    async destroyRemitente({ commit }) {
      commit('destroyRemitente');
    },
  },
};
